<template>
  <div class="rights-editor">
    <v-alert v-if="error" type="error" text class="ma-3">{{ error }}</v-alert>

    <div v-if="loading" class="pa-8 text-center">
      <v-progress-circular indeterminate color="indigo" />
    </div>

    <v-tabs v-else v-model="tab" show-arrows>
      <v-tab>Groupes</v-tab>
      <v-tab>Individus</v-tab>
      <v-tab v-if="args.root !== 'general' && args.target !== 'all'">
        Droits supplémentaires
      </v-tab>

      <v-tabs-items v-model="tab" class="pa-2">
        <v-tab-item>
          <attribDroit
            v-if="datasGroup.listElems"
            :datas="datasGroup"
            :users="datasPerso.listType"
            type="groupe"
            :args="args"
            @reload="loadRights"
          />
        </v-tab-item>

        <v-tab-item>
          <attribDroit
            v-if="datasPerso.listElems"
            :datas="datasPerso"
            type="perso"
            :args="args"
            @reload="loadRights"
          />
        </v-tab-item>

        <v-tab-item>
          <v-row>
            <v-col
              cols="12"
              md="5"
              class="mx-auto rounded text-h6 text-center pa-4 ma-4 red lighten-5 cursor-pointer"
              @click="openGlobalInterfaceRights"
            >
              Droits globaux des éléments du système
            </v-col>
            <v-col
              cols="12"
              md="5"
              class="mx-auto rounded text-h6 text-center pa-4 ma-4 blue lighten-5 cursor-pointer"
              @click="openGeneralRights"
            >
              Droits globaux génériques
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import attribDroit from './attribDroit'
import { openRightsEditor } from './navigation'

export default {
  name: 'RoutingDroits',

  components: { attribDroit },

  props: {
    editorParams: {
      type: Object,
      default: null,
    },
    root: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    targetId: {
      type: [String, Number],
      default: null,
    },
    standalone: Boolean,
  },

  data() {
    return {
      tab: 0,
      datasGroup: {},
      datasPerso: {},
      loading: false,
      error: '',
    }
  },

  computed: {
    args() {
      const source = this.editorParams || {}
      const routeQuery = this.standalone && this.$route ? this.$route.query : {}
      const root = source.root || this.root || routeQuery.root || 'interface'
      const target = source.target || this.target || routeQuery.target || 'all'
      const id = source.id ?? this.targetId ?? routeQuery.id ?? null
      return { root, target, id }
    },
  },

  watch: {
    args: {
      deep: true,
      handler() {
        this.loadRights()
      },
    },
  },

  methods: {
    async loadRights() {
      this.loading = true
      this.error = ''

      try {
        const common = { ...this.args }
        const [groupResponse, personResponse] = await Promise.all([
          this.API({
            type: 'post',
            url: 'engine/droits/init',
            params: { params: { ...common, type: 'groupe' } },
          }),
          this.API({
            type: 'post',
            url: 'engine/droits/init',
            params: { params: { ...common, type: 'perso' } },
          }),
        ])

        this.datasGroup = groupResponse.data || {}
        this.datasPerso = personResponse.data || {}
        const title = this.datasGroup.titlePage || this.datasPerso.titlePage
        if (title) this.$emit('title', title)
        this.$emit('reload')
      } catch (error) {
        this.error = error?.response?.data?.message || error.message || 'Impossible de charger les droits.'
      } finally {
        this.loading = false
      }
    },

    openGlobalInterfaceRights() {
      openRightsEditor({ root: 'interface', target: 'all' })
    },

    openGeneralRights() {
      openRightsEditor({ root: 'general', target: 'all' })
    },
  },

  mounted() {
    this.loadRights()
  },
}
</script>
